
import { apiCall } from './apiCall';
  
  
  
export default function logsApi() {
  return {
    getLogs: (data,token) => apiCall('/getApiLogList',data, token),
    getActivityLogList: (data,token) => apiCall('/getActivityLogList',data, token),
    
  };
}
